import { jsx as _jsx } from "react/jsx-runtime";
import { BlackHatPanel } from '../../Outputs/BlackHatPanel';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
import { usePursuitOutputsWrite } from '../pursuitHooks';
/** Black hat: the Outputs black-hat panel on its own page. */ export function BlackHatSection() {
    const { captureProjectId, zouProjectId } = usePursuitRecord();
    // GRW-30: never writable on a merged stub or for a reader of the header.
    // GRW-30: sections always sit in the record shell, so the gate is the header capabilities.
    const { canEdit } = usePursuitRecord().capabilities;
    const canWrite = usePursuitOutputsWrite(captureProjectId, zouProjectId) && canEdit;
    return /*#__PURE__*/ _jsx(PursuitSectionFrame, {
        title: "Black hat",
        children: /*#__PURE__*/ _jsx(BlackHatPanel, {
            canWrite: canWrite,
            pursuitId: captureProjectId
        })
    });
}
